import type { ReactElement } from 'react'
import styled from 'styled-components'

import { ACTable } from './Table'
import { ChartAnnotation } from '@/components/elements/ChartAnnotation'
import { SectionTitle } from '@/components/elements/SectionTitle'
import { Spacer } from '@/components/elements/Spacer'
import { Table, Thead, Tr, Th } from '@/components/elements/Table'
import { TitleLayout } from '@/components/layout'
import { Head } from '@/components/layouts/Head'
import { Layout } from '@/components/layouts/Ir'
import { Paragraph } from '@/components/layouts/Ir/Paragraph'

export const AnalystCoveragePage = () => {
  return (
    <Layout>
      <SectionTitle
        color="normal"
        titleText="Analyst Coverage"
        subTitleText="アナリストカバレッジ"
      />
      <Spacer h={{ sp: 70, pc: 100 }} />
      <section>
        
        <Paragraph>
          この一覧表は、証券会社や調査機関に所属し、当社株式のレーティング(投資判断)を行っているアナリストを掲載しております。
        </Paragraph>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <section style={{alignItems: 'center', margin:'0% 10%'}}>
          <Annotation>2026年10月現在</Annotation>
          <Annotation>社名50音順・敬称略</Annotation>
          <Spacer h={{ sp: 6, pc: 10 }} />
          <Table>
            <Thead>
              <Tr>
                <Th color={'secondary'} isBold={true} style={{width:'40%', position:"initial"}}>社名</Th>
                <Th color={'secondary'} isBold={true} style={{width:'40%'}}>氏名</Th>
              </Tr>
              <ACTable/>
            </Thead>
          </Table>
        </section>
        <Spacer h={{ sp: 50, pc: 80 }} />
        <Paragraph>
          ※この一覧表は、当社を担当されているアナリストならびにその所属機関についての情報を提供する趣旨のみで掲載しており、当社株式の売買を勧誘するものではありません。従いまして、ご自身の判断と責任において投資判断を行っていただきますようお願い申し上げます。
        </Paragraph>
        <a href="https://sharedresearch.jp/ja/companies/141A" target="_blank" rel="noopener noreferrer"><img src="/images/shared_research_analyst_ja.png" style={{ width: '100%', maxWidth: '336px' }} /></a>
      </section>
    </Layout>
  )
}

AnalystCoveragePage.getLayout = (page: ReactElement) => {
  const breadCrumbs = [
    { name: 'ホーム', path: '/' },
    { name: '株主・投資家向け情報', path: '/ir' },
    { name: '株式情報', path: '/ir/stock' },
    { name: 'アナリストカバレッジ', path: '' },
  ]

  return (
    <>
      <Head
        title="アナリストカバレッジ"
        description="当社を担当されているアナリストを掲載しております。"
        ogp={{ url: 'ir/stock/analyst-coverage/' }}
      />
      <TitleLayout
        title="Investor Relations"
        subTitle="株主・投資家向け情報"
        breadCrumbs={breadCrumbs}
      >
        {page}
      </TitleLayout>
    </>
  )
}

const Annotation = styled(ChartAnnotation)`
  text-align: right;
`
